import styled from 'styled-components';
import { KeywordsStyled } from '../KeywordsStyled';
import { rem } from 'polished';

export const KeywordsStyledOV = styled(KeywordsStyled)`
    font-size: ${rem(12)};
    background-color: ${({ theme }) => theme.colors.pureWhite};
`;
